/**
 * Shared IP geolocation helper.
 *
 * Both locale and currency detection need the visitor's country. This module
 * performs a single request (with a short timeout) and caches the result so the
 * two features never trigger duplicate network calls.
 */

let cachedCountry = null;
let inflightRequest = null;

/**
 * Detect the visitor's ISO 3166-1 alpha-2 country code from their IP address.
 * Returns an uppercase country code, or null when detection fails.
 */
export async function detectCountryFromIP() {
    if (cachedCountry) {
        return cachedCountry;
    }

    if (inflightRequest) {
        return inflightRequest;
    }

    inflightRequest = (async () => {
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 3000);

            const response = await fetch('https://ipapi.co/country/', {
                signal: controller.signal,
            });
            clearTimeout(timeoutId);

            if (!response.ok) {
                return null;
            }

            const countryCode = (await response.text()).trim().toUpperCase();
            cachedCountry = countryCode || null;
            return cachedCountry;
        } catch {
            return null;
        } finally {
            inflightRequest = null;
        }
    })();

    return inflightRequest;
}
